import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Action, NgxsOnInit, State, StateContext } from '@ngxs/store';
import { ApplicationActions } from './application.actions';
import { ApplicationConfig } from '../../../core/config/application.config';
import { LanguageVersion } from '../../model/local/config/language-version';

export interface ApplicationStateModel {
  language: LanguageVersion;
  sidebarCollapsed: boolean;
  loader: Map<string, boolean>;
  featureTitleKey: string;
}

@State<ApplicationStateModel>({
  name: 'application',
  defaults: {
    language: ApplicationConfig.defaultLanguage,
    sidebarCollapsed: false,
    loader: new Map<string, boolean>(),
    featureTitleKey: ''
  },
})
@Injectable()
export class ApplicationState implements NgxsOnInit {
  constructor(private translateService: TranslateService) {}

  ngxsOnInit(ctx: StateContext<ApplicationStateModel>) {
    this.setDefaultLanguage(ctx);
  }

  @Action(ApplicationActions.ChangeLanguage)
  changeLanguage(
    ctx: StateContext<ApplicationStateModel>,
    action: ApplicationActions.ChangeLanguage
  ) {
    const { language } = action;

    setTimeout(() => {
      this.translateService.use(language);
    });

    ctx.patchState({ language: action.language });
  }

  private setDefaultLanguage(ctx: StateContext<ApplicationStateModel>): void {
    this.translateService.setFallbackLang(ApplicationConfig.defaultLanguage);
    const language: LanguageVersion =
      ctx.getState().language || ApplicationConfig.defaultLanguage;

    ctx.dispatch(new ApplicationActions.ChangeLanguage(language));
  }

  @Action(ApplicationActions.SetLoading, { cancelUncompleted: true })
  setLoading(
    ctx: StateContext<ApplicationStateModel>,
    action: ApplicationActions.SetLoading
  ) {
    const { loading, url } = action;

    if (!url) {
      throw new Error(
        'The request URL must be provided to the LoadingService.setLoading function'
      );
    }

    const loadingMap = new Map<string, boolean>(ctx.getState().loader);

    if (loading) {
      loadingMap.set(url, true);
    } else {
      loadingMap.delete(url);
    }

    ctx.patchState({ loader: loadingMap });
  }

  @Action(ApplicationActions.SetFeatureTitleKey)
  public setFeatureTitleKey(ctx: StateContext<ApplicationStateModel>, action: ApplicationActions.SetFeatureTitleKey) {

    ctx.patchState({ featureTitleKey: action.featureTitleKey });
  }
}
